export const deleteTextBeforeCursor = (text) => {
    const deleteTextBeforeCursorInner = (state, dispatch) => {
        const { tr, selection } = state;
        if (!selection.empty) {
            return false;
        }
        const { nodeBefore } = selection.$from;
        if (!nodeBefore ||
            !nodeBefore.isText ||
            !nodeBefore.textContent.endsWith(text)) {
            return false;
        }
        tr.delete(selection.from - text.length, selection.from);
        dispatch === null || dispatch === void 0 ? void 0 : dispatch(tr);
        return true;
    };
    return deleteTextBeforeCursorInner;
};
//# sourceMappingURL=deleteTextBeforeCursor.js.map